
import { usePermissions } from "../../hooks/usePermissions";

export function PermissionGate({
  permission,
  anyOf = [],
  allOf = [],
  fallback = null,
  children,
}) {
  const {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
  } = usePermissions();

  const allowed =
    hasPermission(permission) &&
    hasAnyPermission(anyOf) &&
    hasAllPermissions(allOf);

  return allowed ? children : fallback;
}
